<template>
  <div>
    <template v-if="type == 'Job'">
      <JobCard
        v-for="job in results.data"
        :key="job.job_id"
        :job="job"
        match="true"
      />
    </template>
    <Pagination :results="results" :api="api" v-model="results" />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
export default {
  props: {
    type: String,
    action: String,
    api: String,
    results: Object
  },
  components: {
    JobCard
  }
};
</script>

<style scoped></style>
